import { render, staticRenderFns } from "./MentorshipRequestsTable.vue?vue&type=template&id=8c79809e&scoped=true&"
import script from "./MentorshipRequestsTable.vue?vue&type=script&lang=js&"
export * from "./MentorshipRequestsTable.vue?vue&type=script&lang=js&"
import style0 from "./MentorshipRequestsTable.vue?vue&type=style&index=0&id=8c79809e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c79809e",
  null
  
)

export default component.exports